import React from "react";
import { useCurrentUser } from "../../../utils/CurrentUserContext";
import dayjs from "dayjs";
import AdvertiserCostTable from "./BillingComponents/AdvertiserCostTable";
import { AgencyCostProps } from "./BillingComponents/costUtils";
import DateSelect from "../../../components/buttons/DateSelect";
import { useDateRange } from "../../../utils/date-utils";

const AgencyCost: React.FC<AgencyCostProps> = () => {
  const { user } = useCurrentUser();
  
  // Using the enhanced useDateRange hook 
  const {
    dateRange,
    handleDateChange,
    formattedDateRange
  } = useDateRange(
    [dayjs().startOf("month"), dayjs().endOf("month")], // Default to current month
    300 // 300ms debounce
  );
  
  // Extract query start and end for the AdvertiserCostTable
  const [queryStart, queryEnd] = formattedDateRange;

  return (
    <div className="pb-4 bg-white rounded-lg shadow-lg py-2">
      <div className="px-2 sm:px-6 lg:px-4 py-4">
        <div className="sm:flex sm:items-center p-2">
          <div className="sm:flex-auto">
            <h1 className="text-lg leading-6 font-medium text-gray-900 pb-2">
              Cost
            </h1>
            <DateSelect 
              dateRange={dateRange}
              handleDate={handleDateChange}
            />
          </div>
        </div>

        <AdvertiserCostTable
          queryStart={queryStart}
          queryEnd={queryEnd}
          user={user}
        />
      </div>
    </div>
  );
};

export default AgencyCost;